import { render, staticRenderFns } from "./KpiSocial.vue?vue&type=template&id=dfb8c34a"
import script from "./KpiSocial.vue?vue&type=script&lang=js"
export * from "./KpiSocial.vue?vue&type=script&lang=js"
import style0 from "./KpiSocial.vue?vue&type=style&index=0&id=dfb8c34a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports